import {
  TRACKED_KEYWORD,
  TRACKED_KEYWORD_SENTIMENT,
} from '@modules/common/constants';

const getFieldNameToDisplay = (fieldName: string) => {
  return fieldName
    .replace(/Entity/i, TRACKED_KEYWORD)
    .replace(/Reason/i, 'Reason')
    .replace(/EntitySentiment/i, TRACKED_KEYWORD_SENTIMENT)
    .replace(/ReviewSentiment/i, 'User Sentiment')
    .replace(/_/g, ' - ');
};

export default getFieldNameToDisplay;
